import React from 'react'

import { COLORS } from '~/common/globalStyles'

export interface BasicLogoProps {
  width?: string
  height?: string
  fill: keyof typeof COLORS
  Svg: React.ComponentType<any>
}

const BasicLogo: React.FC<BasicLogoProps> = ({ Svg, width, height, fill }) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 482 114"
    width={width}
    height={height}
  >
    <svg
      id="Layer_2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 499.21 102.33"
    >
      <defs></defs>
      <g id="Layer_1-2" fill={fill}>
        <g>
          <g>
            <g>
              <path
                className="cls-1"
                d="M132.72,51.16c0-30.42,18.56-40.64,35-40.64,9.87,0,21.03,3.29,28.54,14.68l-12.1,8.93c-5.29-6.7-10.45-9.4-16.68-9.4-10.81,0-17.5,8.93-17.5,25.37,0,17.38,5.4,27.72,18.68,27.72,4.35,0,8.69-1.06,11.75-2.58v-15.15h-11.86v-13.04h27.37v36.65c-6.46,4.58-16.8,7.75-28.07,7.75-21.5,0-35.12-13.16-35.12-40.29Z"
              />
              <path
                className="cls-1"
                d="M208.11,64.79V11.93h16.8V63.96c0,10.34,5.64,13.39,13.51,13.39s12.92-4.23,12.92-12.8V11.93h16.8v54.62c0,15.62-12.33,24.9-30.19,24.9-19.73,0-29.83-7.99-29.83-26.66Z"
              />
              <path
                className="cls-1"
                d="M297.08,11.93V90.04h-16.8V11.93h16.8Z"
              />
              <path
                className="cls-1"
                d="M335.54,11.93c22.91,0,37.24,11.63,37.24,36.3,0,30.78-17.5,41.82-36.77,41.82h-26.78V11.93h26.31Zm20.32,38.41c0-19.85-9.51-25.14-21.03-25.14h-8.81v51.68h10.22c12.1,0,19.62-8.93,19.62-26.55Z"
              />
              <path
                className="cls-1"
                d="M433.74,11.93v14.68h-32.07v16.33h27.49v14.57h-27.49v17.85h32.89v14.68h-49.69V11.93h48.86Z"
              />
            </g>
            <path
              className="cls-1"
              d="M0,0V102.33H102.34V0H0ZM85.93,39.57h-3.84s-.02,.01-.02,.01h-30.9c-6.39,0-11.59,5.19-11.59,11.58s5.2,11.58,11.59,11.58h19.31v3.94h-.01c-.04,2.1-1.74,3.79-3.85,3.79h-15.45c-10.65,0-19.31-8.66-19.31-19.31s8.66-19.31,19.31-19.31h34.76v7.72Zm0-15.48h-3.46c-.13,0-.26,.03-.4,.03h-30.9c-14.91,0-27.04,12.13-27.04,27.04s12.13,27.04,27.04,27.04h15.45c6.39,0,11.59-5.2,11.59-11.59v-11.59h-27.04c-2.13,0-3.86-1.73-3.86-3.86s1.73-3.86,3.86-3.86h34.76v19.31c0,10.65-8.66,19.3-19.31,19.3h-15.45c-19.16,0-34.76-15.58-34.76-34.75S32.01,16.41,51.17,16.41h34.76v7.68Z"
            />
          </g>
          <g>
            <path
              className="cls-1"
              d="M445.99,27.37c0-12.72,7.71-16.42,13.67-16.42,3.64,0,7.96,1.13,10.84,5.52l-3.26,2.57c-2.19-2.82-4.64-4.07-7.52-4.07-5.08,0-8.84,3.76-8.84,12.22,0,7.33,2.63,12.66,9.34,12.66,2.57,0,5.2-.82,7.71-2.82l2.07,3.32c-2.01,1.82-5.77,3.57-10.15,3.57-9.03,0-13.85-6.14-13.85-16.55Z"
            />
            <path
              className="cls-1"
              d="M473.32,11.83h5.2l7.4,11.47,7.65-11.47h5.01l-10.15,14.79,10.78,16.36h-5.2l-8.27-12.72-8.65,12.72h-5.08l11.16-16.24-9.84-14.92Z"
            />
          </g>
        </g>
      </g>
    </svg>
  </Svg>
)

export default BasicLogo
